var appSettings = require("./appSetting.json");

export const API_BASE_URL = appSettings.api_base_url;
export const ACCOUNT_ICON_DOC_ID = appSettings.account_icon_document_id;
export const DATE_DISPLAY_FORMAT = appSettings.date_display_format;
